module.exports = __webpack_public_path__ + "static/onepager-background-d24e5d2eaf15fd3a3f262bff2517b814.png";